import { useMemo } from 'react'
import { ThemeProvider, useTheme } from 'styled-components'
import { getInvertedTheme } from './theme'

export const InvertedThemeProvider = ({ children }) => {
  const theme = useTheme()
  const invertedTheme = useMemo(() => getInvertedTheme(theme), [theme])
  return <ThemeProvider theme={invertedTheme}>{children}</ThemeProvider>
}
